import React, { useState, useCallback } from 'react';
import { Eye, EyeOff, Maximize2, Minimize2 } from 'lucide-react';
import { useValueVisibility } from '../../contexts/ValueVisibilityContext';
import PinModal from '../Modal/PinModal';

function DashboardHeader({ currentTime, isMLConnected, storeName }) {
    const {
        showValues,
        toggleValues,
        pinModalOpen,
        handlePinSuccess,
        handlePinCancel
    } = useValueVisibility();

    const [isFullscreen, setIsFullscreen] = useState(false);

    const toggleFullscreen = useCallback(() => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            setIsFullscreen(true);
        } else {
            document.exitFullscreen();
            setIsFullscreen(false);
        }
    }, []);

    return (
        <>
        <div style={{
            backgroundColor: '#2D3277',
            padding: '4px 15px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            color: 'white',
            height: '48px'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <div style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: isMLConnected ? '#00a650' : '#ff4444'
                    }} />
                    <span>{isMLConnected ? 'Conectado ML' : 'Desconectado ML'}</span>
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <span>{currentTime.toLocaleDateString('pt-BR')}</span>
                    <span style={{ color: '#FFE600' }}>|</span>
                    <span>{currentTime.toLocaleTimeString('pt-BR', {
                        hour: '2-digit',
                        minute: '2-digit'
                    })}</span>
                </div>

                <button
                    onClick={toggleValues}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'white' }}
                >
                    {showValues ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>

                <button
                    onClick={toggleFullscreen}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'white' }}
                    title={isFullscreen ? 'Sair do fullscreen' : 'Fullscreen'}
                >
                    {isFullscreen ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
                </button>

                 {/* Nome da Loja */}
    <h2 style={{
        margin: 0,
        color: 'white',
        fontSize: '1.4rem', // Tamanho maior
        fontWeight: '600',  // Mais negrito
        marginLeft: '40px'  // Espaçamento extra à esquerda
    }}>
        {storeName}
    </h2>

            </div>
        </div>

        {pinModalOpen && (
            <PinModal 
                mode="validate"
                onSuccess={handlePinSuccess}
                onClose={handlePinCancel}
            />
        )}
        </>
    );
}

export default DashboardHeader;